/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Button,
  Card,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'

// @context
import { useUI } from '../../app/context/ui'

// @assets
import { DashboardStyles } from '../../assets/css/dashboard-style'

// @helpers
import { getTemplateForCertification } from '../../helpers/FunctionsUtils'

// @components
import Pageheader from '../../components/PageHeader'
import { GeneralStyles } from '../../assets/css/general-style'

// @services
//import HelpersServiceNewApi from '../../services/newApi/HelpersServiceNewApi'
//import AppHelper from '../../helpers/AppHelper'

const LIST_STATES = [
  {
    id: "AZ",
    name: "Arizona"
  }
]

const BulkTemplate = () => {
  const styles = useMemo(() => DashboardStyles(), []);
  const generalStyle = useMemo(() => GeneralStyles(), []);
  //const statesService = useMemo(() => new HelpersServiceNewApi(), []);
  const { blockUI, snackbarUI } = useUI()
  const { user } = useSelector((state) => state)

  const [stateSelected, setStateSelected] = useState('');
  //const [states, setStates] = useState([]);

  // TODO: only when the client needs to get more than one state
  /* const getStates = async () => {
    try {
        blockUI.current.open(true);
        const response = await statesService.getLocalities()
        setStates(response?.data?.data);
        blockUI.current.open(false);      
    } catch (e) {
        blockUI.current.open(false);      
        AppHelper.check(e, snackbarUI);
    }
  }; */

  /* useEffect(() => {
    getStates();
  }, []); */

  const handleDownload = async () => {
    if (!stateSelected) return
    const params = {
      pathUrl: `/api/internal/v1/submitter/arizona`,
      token: user?.accessToken,
      fileName: `bulk_template_for_${stateSelected}.csv`,
      blockUI,
      snackbarUI,
    }
    getTemplateForCertification(params);
  }

  return (
    <Grid sx={styles.containerBulkTemplate}>
        <Container
          component="div"
          maxWidth="xl"
          sx={{
            ...styles.upperCtn,
            marginBottom: '25px',
          }}
        >
          <Pageheader
              title={'Bulk template'}
              subtitle={`Welcome to bulk template dashboard`}
          />
        </Container>
        
        <Container
          component="div"
          maxWidth="xl"
          sx={{
            ...styles.upperCtn,
            marginBottom: '25px',
          }}
        >
            <Card
                elevation={1}
                sx={{
                    ...styles.containerIsMonday,
                    padding: '30px 20px',
                }}
            >
                <Typography sx={styles.titleBulk}>Download files by state</Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={8}>
                        <FormControl fullWidth>
                            <InputLabel id="state-select-label">State</InputLabel>
                            <Select
                            labelId="state-select-label"
                            id="state-select"
                            label="State"
                            value={stateSelected}
                            sx={styles.selectBulkTemplate}
                            onChange={(e) => setStateSelected(e.target.value)}
                            >
                                <MenuItem value="">Select</MenuItem>
                                {LIST_STATES.map((st) => (
                                    <MenuItem key={st.name} value={st.name}>
                                    {st.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <Button
                            sx={generalStyle.customButtonMain}
                            onClick={handleDownload}
                            disabled={!stateSelected}
                        >
                          Download
                        </Button>
                    </Grid>
                </Grid>
                
            </Card>
        </Container>
    </Grid>
  )
}

export default BulkTemplate